export type Input = {
  id?: string;
  number: string;
  title: string;
  description: Marko.AttrTag<{content: Marko.Body}>;
  statement: Marko.AttrTag<{content: Marko.Body}>;
  style?: Marko.CSS.Properties;
}

<let/sectionStyle={
  "z-index": 1000,
  "background-color": "var(--color-background)",
  ...(input.style ?? {})
} as Marko.CSS.Properties />


<article id=input.id class="principle-article light paper" style=sectionStyle>
  <div class="principle-number">${input.number}</div>
  <h3 class="principle-title">${input.title}</h3>
  <div class="principle-description">
    <${input.description}/>
  </div>
  <div class="principle-card">
    <div class="principle-icon">
      <icon name="book-heart"/>
    </div>
    <p class="principle-statement"><${input.statement}/></p>
  </div>
</article>

<style.scss>
  .principle-article {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: left;
    height: 100%;

    background-color: var(--color-card-background);
    border: 1px solid var(--color-border);
    border-radius: 16px;

    padding: 3rem 2rem;

    & > p {
      margin-bottom: 1rem;
      font-size: 1rem;
      line-height: 1.7;
    }
  }

  .principle-number {
    display: flex;
    font-size: 3rem;
    line-height: 2rem;
    font-weight: 300;
    color: var(--color-text-subtle);
  }

  .principle-title {
    display: flex;
    font-size: 2rem;
    font-weight: 400;
    color: var(--color-text);
    margin-bottom: 1.5rem;
  }

  .principle-card {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    border: 1px solid var(--color-border-subtle);
    border-radius: 8px;
    padding: 1.5rem;
    margin-top: 1.5rem;

    & p {
      margin: 0;
    }
  }

  .principle-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
  }

  .principle-statement {
    font-size: 1rem;
    font-style: italic;
    color: var(--color-text);
    margin: 0;
    line-height: 1.6;
  }

  /* Mobile */
  @media (max-width: 1024px) {    
    .principle-article {
      display: flex;
      flex-direction: column;
      width: 100vw;
      padding: 2rem;
      border-width: 0;

      & h3 {
        margin: 1.5rem 0;
      }
    }

    .principle-description {
      display: flex;
      flex-basis: 50%;
      flex-direction: column;
      flex-grow: 1;
      flex-shrink: 1;
      overflow: scroll;
    }

    .principle-card {
      padding: 1rem;
      margin: 0;
    }
  }
</style>